import React from 'react';
import { getIncomeSource, getClientId, closeVipSubscribeDialog } from '@/utils/vip';
import InfoIcon from '@/assets/image/vip/info-icon.png';
import Modal from '../modal';
import { visibleBindPhoneAtom } from '@/store';
import { useAtom } from 'jotai';
import { useLocaleStore } from '@/i18n/localeStore';

import styles from './index.module.css';

const BindPhone = () => {
  const { $t } = useLocaleStore();
  const [visibleBindPhone, setVisibleBindPhone] = useAtom(visibleBindPhoneAtom);

  const handleClose = () => {
    setVisibleBindPhone(false);
    closeVipSubscribeDialog({
      success: true,
    });
  };

  const handleJump = () => {
    // 未绑定手机号
    let prefix = process.env.REACT_APP_ENV;

    if (process.env.REACT_APP_ENV === 'release') {
      prefix = '';
    }
    // client_callback=0,绑定成功后直接跳回用户主页
    const jumpUrl = `https://${prefix}account.meitu.com/#!/client/dispatch?client_id=${getClientId()}&action=bind_phone&client_callback=0&copyright=hide`;

    if (getIncomeSource() !== 'MTXX-WEB') {
      window.location.href = jumpUrl;
    } else {
      window.top?.open(jumpUrl);
      handleClose();
    }
  };

  return (
    <Modal style={{ width: '320px' }} visible={visibleBindPhone} onClose={handleClose}>
      <div className={styles.body}>
        <div className={styles.modalTitel}>
          <img className={styles.modalIcon} src={InfoIcon} alt="" />
          <span>{$t((v) => v.Title_BindPhone)}</span>
        </div>
        <div className={styles.modalDesc}>
          {$t((v) => v.Desc_ProtectMemberExperience)}
          <br />
          {$t((v) => v.Desc_BindPhoneFirst)}
        </div>
        <div className={styles.modalFooter}>
          <div className={styles.cancel} onClick={handleClose}>
            {$t((v) => v.Button_Skip)}
          </div>
          <div className={styles.confirm} onClick={handleJump}>
            {$t((v) => v.Button_GoToBind)}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default BindPhone;
